module.exports = __webpack_public_path__ + "media/images/bonusForSharing__bg-ab4e7470a15db3a119453b8cd7742186.jpg";